import KpiCard from '../common/KpiCard';
import useMetric from '../../hooks/useMetric';
import { changePct, formatNumber } from '../../utils/format';

export default function LeadKpiCard() {
  const { status, data, error, retry } = useMetric('leads');
  return (
    <KpiCard
      testId="kpi-leads" title="Leads Captured" icon="bi-person-plus-fill" tone="warning" to="/conversations"
      status={status} error={error} onRetry={retry} emptyText="No leads captured yet."
      value={data && formatNumber(data.value)} delta={data && changePct(data.value, data.previous)}
      sparkline={data?.sparkline} footnote="Visitors who shared contact details"
    />
  );
}
